import type { NotifyConfiguration } from '@/api/fe-api/__generated__/oazapfts-client';
import {
  type AlertNotificationRule,
  AlertNotificationRuleSchema,
} from '@/api/fe-api/domain/entities/alert-notifications';

export function notificationRuleMapper(
  data: NotifyConfiguration,
): AlertNotificationRule {
  const raw: unknown = {
    id: data.uuid,
    isEnabled: data.active,
    description: data.name,
    minAlertStatus: data.minimum_alert_level,
    siteIds: data.site_accure_ids,
    channels: ['Email'],
    externalEmails: data.recipient_emails,
    frequency: data.frequency,
  };

  const result = AlertNotificationRuleSchema.safeParse(raw);

  if (result.success) {
    return result.data;
  }

  console.error('Failed to parse AlertNotificationRule:', result.error);
  throw new Error(
    'Invalid job details: ' + JSON.stringify(result.error.format()),
  );
}
